module.exports = __webpack_public_path__ + "f6f8771b73910016aad70d99f5f0511f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/boots-city.png
// module id = 1878
// module chunks = 0